var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('vs-row',{staticClass:"full-height",attrs:{"vs-align":"center","vs-type":"flex","vs-justify":"center","vs-w":"12"}},[_c('vs-col',{attrs:{"vs-type":"flex","vs-justify":"center","vs-align":"center","vs-xs":"12","vs-sm":"10","vs-lg":"8"}},[_c('RegisterForm')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }